import React from 'react';
import { useParams, Link } from 'react-router-dom';
import {
  useGetFscHouseholdQuery,
  useListFscHouseholdDocumentsQuery,
} from '../../app/api';
import { useIsMobile } from '../utils';
import FscDocumentTree from './FscDocumentTree';

const brand = {
  deepBlue:  '#0a2947',
  tealBlue:  '#0069a6',
  goldenrod: '#d09b2c',
  charcoal:  '#58585b',
  softGray:  '#e9e6e1',
};

export default function FscClientDetail() {
  const { fscId } = useParams();
  const isMobile = useIsMobile();

  const { data: household, isLoading: loadingHh, isError } = useGetFscHouseholdQuery({ id: fscId });
  // Only for the header count. FscDocumentTree issues the identical query, and
  // RTK Query serves both subscribers from one cache entry, so this is a shared
  // result rather than a second request.
  const { data: docsData } = useListFscHouseholdDocumentsQuery({ id: fscId, limit: 1000 });
  const documents = docsData?.documents || [];

  if (isError) {
    return (
      <div style={{ background: brand.softGray, minHeight: '100vh', padding: '1.5rem' }}>
        <p style={{ color: brand.charcoal }}>
          That household isn&apos;t in the local cache.{' '}
          <Link to="/work/clients/fsc">Back to Salesforce Clients</Link>
        </p>
      </div>
    );
  }

  return (
    <div style={{ background: brand.softGray, minHeight: '100vh', padding: isMobile ? '0.75rem' : '1.5rem' }}>
      <Link to="/work/clients/fsc" style={{ fontSize: '0.82rem', color: brand.tealBlue, textDecoration: 'none' }}>
        <i className="bi bi-chevron-left" /> Salesforce Clients
      </Link>

      {/* Household header */}
      <div style={{ background: 'white', borderRadius: 12, boxShadow: '0 2px 12px rgba(10,41,71,0.1)', overflow: 'hidden', margin: '0.75rem 0 1.25rem' }}>
        <div style={{ background: brand.deepBlue, borderBottom: `3px solid ${brand.goldenrod}`, padding: '0.875rem 1.25rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <i className="bi bi-house-fill" style={{ color: brand.goldenrod }} />
          <h5 style={{ color: 'white', fontWeight: 700, fontSize: '0.85rem', textTransform: 'uppercase', letterSpacing: '1px', margin: 0 }}>
            {loadingHh ? 'Loading…' : (household?.name || 'Household')}
          </h5>
        </div>
        <div style={{ padding: '1rem 1.25rem', display: 'flex', gap: '2rem', flexWrap: 'wrap' }}>
          {[
            ['Advisor', household?.rep_name],
            ['Office', household?.rep_firm_name],
            ['Owner', household?.owner_name],
            ['Orion / source id', household?.source_system_id],
            ['Documents', documents.length.toLocaleString()],
          ].map(([label, value]) => (
            <div key={label}>
              <div style={{ fontSize: '0.68rem', fontWeight: 700, letterSpacing: '0.5px', textTransform: 'uppercase', color: brand.charcoal }}>
                {label}
              </div>
              <div style={{ color: brand.deepBlue, fontSize: '0.9rem', fontWeight: 600 }}>
                {value || '—'}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Document tree */}
      <div style={{ background: 'white', borderRadius: 12, boxShadow: '0 2px 12px rgba(10,41,71,0.1)', overflow: 'hidden' }}>
        <FscDocumentTree fscHouseholdId={fscId} isMobile={isMobile} />
      </div>
    </div>
  );
}
